import { render, staticRenderFns } from "./UserLoginRegister.vue?vue&type=template&id=93ed588c&scoped=true&"
import script from "./UserLoginRegister.vue?vue&type=script&lang=js&"
export * from "./UserLoginRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ed588c",
  null
  
)

export default component.exports